import { render, staticRenderFns } from "./_title.vue?vue&type=template&id=2886a37e&scoped=true"
import script from "./_title.vue?vue&type=script&lang=js"
export * from "./_title.vue?vue&type=script&lang=js"
import style0 from "./_title.vue?vue&type=style&index=0&id=2886a37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886a37e",
  null
  
)

export default component.exports